import AddSingleActivity from './AddSingleActivity';
export default AddSingleActivity;
